import { Modal } from "@components/modal";
import Warning from "@assets/icons/warning-filled.svg";
import { Button } from "@components/button";
import styles from "./confirm.module.scss";

type Props = {
  hide: () => void;
  isOpen: boolean;
  onConfirm: () => void;
};

export const ApplyPayoutConfirm = ({ hide, isOpen, onConfirm }: Props) => {

  return (
    <>
      <Modal isOpen={isOpen} onClose={hide} className={styles.confirm}>
        <div className={styles.confirmContainer}>
          <Warning />
          <p className={styles.title}>Вы уверены?</p>
          <p className={styles.subTitle}>
            Принятие заявки в работу
          </p>
        </div>
        <div className={styles.buttons}>
          <Button onClick={onConfirm}>Да</Button>
          <Button type="danger" onClick={hide}>
            Нет
          </Button>
        </div>
      </Modal>
      {/* {isUpdating && <GlobalLoader />} */}
    </>
  );
};
